import ButtonCta from "@/components/common/ButtonCta";
import {
    getOriginalAmount,
    getTourId,
} from "@/store/checkout/selector-checkout";
import { useStore } from "@/store/index";
import { verifyCoupon } from "@/utils/queries";
import { useMutation } from "@tanstack/react-query";
import React from "react";
import styles from "@/styles/checkout/SummaryCheckoutCard.module.scss";

const DiscountSectionDetail = () => {
    const dispatchCommon = useStore(state => state.dispatchCommon);
    const dispatch = useStore(state => state.dispatchCheckout);
    const setErrorMsg = useStore(state => state.setErrorMsg);
    const originalAmount = useStore(getOriginalAmount);
    const tourId = useStore(getTourId);
    // eslint-disable-next-line no-underscore-dangle
    const userId = useStore(state => state.userState.userDetail._id);

    const { mutate: checkCoupon } = useMutation(verifyCoupon, {
        onSettled: () => {
            dispatchCommon({ type: "SET_LOADER_PAGE", payload: false });
        },
        onSuccess: ({ coupon, discountedAmount }) => {
            // Success actions
            dispatch({
                type: "SET_COUPON",
                payload: coupon,
            });
            dispatch({
                type: "SET_TOTAL_AMOUNT",
                payload: discountedAmount,
            });
        },
        onError: err => {
            // Error actions
            setErrorMsg(err as never);
        },
    });

    if (!userId) {
        return null;
    }

    return (
        <ButtonCta
            validator={value => !!value.trim()}
            className={`${styles.inputDiscountField} mb-3`}
            onClick={(value: string) => {
                dispatchCommon({
                    type: "SET_LOADER_PAGE",
                    payload: true,
                });
                checkCoupon({
                    code: value,
                    originalAmount,
                    tourId,
                });
            }}
            placeholder="Enter your coupon code"
            isSmall
        />
    );
};

export default DiscountSectionDetail;
